module.exports = __webpack_public_path__ + "img/icon-envelope.cc131240.svg";